// Fix ngComponentOutlet and icons module in IE
// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/prepend()/prepend().md
function polyfillPrepend() {
    var arr = [Element.prototype, Document.prototype, DocumentFragment.prototype];
    arr.forEach(function (item) {
        if (item.hasOwnProperty('prepend')) {
            return;
        }
        Object.defineProperty(item, 'prepend', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function prepend() {
                var argArr = Array.prototype.slice.call(arguments), docFrag = document.createDocumentFragment();
                argArr.forEach(function (argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });
                this.insertBefore(docFrag, this.firstChild);
            }
        });
    });
}

var KEYS;
(function (KEYS) {
    KEYS["Backspace"] = "Backspace";
    KEYS["Tab"] = "Tab";
    KEYS["Enter"] = "Enter";
    KEYS["Escape"] = "Escape";
    KEYS["Space"] = " ";
    KEYS["End"] = "End";
    KEYS["Home"] = "Home";
    KEYS["ArrowLeft"] = "ArrowLeft";
    KEYS["ArrowUp"] = "ArrowUp";
    KEYS["ArrowRight"] = "ArrowRight";
    KEYS["ArrowDown"] = "ArrowDown";
    KEYS["Left"] = "Left";
    KEYS["Up"] = "Up";
    KEYS["Right"] = "Right";
    KEYS["Down"] = "Down";
    KEYS["Delete"] = "Delete";
    KEYS["Zero"] = "0";
    KEYS["One"] = "1";
    KEYS["Two"] = "2";
    KEYS["Three"] = "3";
    KEYS["Four"] = "4";
    KEYS["Five"] = "5";
    KEYS["Six"] = "6";
    KEYS["Seven"] = "7";
    KEYS["Eight"] = "8";
    KEYS["Nine"] = "9";
    KEYS["a"] = "a";
    KEYS["b"] = "b";
    KEYS["c"] = "c";
    KEYS["d"] = "d";
    KEYS["e"] = "e";
    KEYS["f"] = "f";
    KEYS["g"] = "g";
    KEYS["h"] = "h";
    KEYS["i"] = "i";
    KEYS["j"] = "j";
    KEYS["k"] = "k";
    KEYS["l"] = "l";
    KEYS["m"] = "m";
    KEYS["n"] = "n";
    KEYS["o"] = "o";
    KEYS["p"] = "p";
    KEYS["q"] = "q";
    KEYS["r"] = "r";
    KEYS["s"] = "s";
    KEYS["t"] = "t";
    KEYS["v"] = "v";
    KEYS["w"] = "w";
    KEYS["x"] = "x";
    KEYS["y"] = "y";
    KEYS["z"] = "z";
    KEYS["A"] = "A";
    KEYS["B"] = "B";
    KEYS["C"] = "C";
    KEYS["D"] = "D";
    KEYS["E"] = "E";
    KEYS["F"] = "F";
    KEYS["G"] = "G";
    KEYS["H"] = "H";
    KEYS["I"] = "I";
    KEYS["J"] = "J";
    KEYS["K"] = "K";
    KEYS["L"] = "L";
    KEYS["M"] = "M";
    KEYS["N"] = "N";
    KEYS["O"] = "O";
    KEYS["P"] = "P";
    KEYS["Q"] = "Q";
    KEYS["R"] = "R";
    KEYS["S"] = "S";
    KEYS["T"] = "T";
    KEYS["V"] = "V";
    KEYS["W"] = "W";
    KEYS["X"] = "X";
    KEYS["Y"] = "Y";
    KEYS["Z"] = "Z";
    KEYS["Numpad0"] = "0";
    KEYS["Numpad1"] = "1";
    KEYS["Numpad2"] = "2";
    KEYS["Numpad3"] = "3";
    KEYS["Numpad4"] = "4";
    KEYS["Numpad5"] = "5";
    KEYS["Numpad6"] = "6";
    KEYS["Numpad7"] = "7";
    KEYS["Numpad8"] = "8";
    KEYS["Numpad9"] = "9";
    KEYS["Comma"] = ",";
    KEYS["DecimalPoint"] = ".";
    KEYS["MSDecimalPoint"] = "Decimal";
    KEYS["Period"] = ".";
})(KEYS || (KEYS = {}));

// Returns true if key is betwwen 0-9
function IS_DIGIT_KEY(key) {
    return (key === KEYS.Zero ||
        key === KEYS.One ||
        key === KEYS.Two ||
        key === KEYS.Three ||
        key === KEYS.Four ||
        key === KEYS.Five ||
        key === KEYS.Six ||
        key === KEYS.Seven ||
        key === KEYS.Eight ||
        key === KEYS.Nine);
}
function IS_NAVIGATION_KEY(key) {
    return key === KEYS.Tab || key === KEYS.Home || key === KEYS.End;
}
function IS_SYSTEM_KEY(event) {
    return IS_NAVIGATION_KEY(event.key) || IS_SHORTCUT_KEY(event) || IS_DELETE_KEY(event.key);
}
function IS_DELETE_KEY(key) {
    return key === KEYS.Backspace || key === KEYS.Delete;
}
function IS_ENTER_KEY(key) {
    return key === KEYS.Enter;
}
function IS_LETTER_KEY(key) {
    var code = key.charCodeAt(0);
    return (code > 64 && code < 91) || (code > 96 && code < 123);
}
function IS_SHORTCUT_KEY(event) {
    return (event.ctrlKey &&
        (event.key === KEYS.A ||
            event.key === KEYS.C ||
            event.key === KEYS.X ||
            event.key === KEYS.Y ||
            event.key === KEYS.Z ||
            event.key === KEYS.a ||
            event.key === KEYS.c ||
            event.key === KEYS.x ||
            event.key === KEYS.y ||
            event.key === KEYS.z)) ||
        (event.shiftKey &&
            (event.key === KEYS.Tab ||
                event.key === KEYS.Home ||
                event.key === KEYS.End));
}
function GET_NUMBER_CHAR(key) {
    switch (key) {
        case KEYS.Zero:
            return '0';
        case KEYS.One:
            return '1';
        case KEYS.Two:
            return '2';
        case KEYS.Three:
            return '3';
        case KEYS.Four:
            return '4';
        case KEYS.Five:
            return '5';
        case KEYS.Six:
            return '6';
        case KEYS.Seven:
            return '7';
        case KEYS.Eight:
            return '8';
        case KEYS.Nine:
            return '9';
        default:
            return '';
    }
}

function coerceBooleanProperty(value) {
    return value != null && "" + value !== 'false';
}
function UkBoolean() {
    return function (target, propertyKey) {
        var _value;
        Object.defineProperty(target, propertyKey, {
            get: function () { return _value; },
            set: function (value) { return _value = coerceBooleanProperty(value); },
            enumerable: true,
            configurable: true
        });
    };
}

export { GET_NUMBER_CHAR, IS_DELETE_KEY, IS_DIGIT_KEY, IS_ENTER_KEY, IS_LETTER_KEY, IS_NAVIGATION_KEY, IS_SHORTCUT_KEY, IS_SYSTEM_KEY, KEYS, UkBoolean, coerceBooleanProperty, polyfillPrepend };
//# sourceMappingURL=uikit-components-helpers.js.map
